import { round, sprintf } from "../../helpers/helpers";
import References from "../../helpers/Reference";
import AuthService from "../Auth/auth.modules";

import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

import waterState_2 from '../../images/water_-2.svg';
import waterState0 from '../../images/water_0.svg';
import waterState10 from '../../images/water_10.svg';
import waterState20 from '../../images/water_20.svg';
import waterState30 from '../../images/water_30.svg';
import waterState40 from '../../images/water_40.svg';

import rainState_2 from '../../images/rain_-2.svg';
import rainState_0 from '../../images/rain_0.svg';
import rainState_10 from '../../images/rain_10.svg';
import rainState_20 from '../../images/rain_20.svg';
import rainState_30 from '../../images/rain_30.svg';
import rainState_40 from '../../images/rain_40.svg';

export const loadEventSituation = ( finish, loaded ) => {
    if (loaded) {
        return Promise.resolve(null);
    }
    const url = sprintf(
        References.api.event_situation_summary,
        encodeURIComponent(dayjs(finish, References.dateFormat).format()),
    )
    return AuthService.fetch(url)
        .then(res => res.json())
        .catch(() => {throw new Error()});
}

export const loadEventFiltered = (start, finish, filter) => {

    let startCalc = dayjs(start, References.dateFormat).format();
    let finishCalc = dayjs(finish, References.dateFormat).format();

    let params = '';

    //фильтрация по постам
    if (filter?.station?.id) {    
         params += '&station=' +filter.station.id.station;
         startCalc = filter.station.id.date;
         finishCalc = filter.station.id.date
    }
 
    //фильтрация по измерителям
    if (filter?.event_type?.id)
         params += '&mch=' + filter.event_type.id.mch

    //фильтрация по дате
    if (filter?.date?.id) {
        startCalc = filter.date.id.date;
        finishCalc = filter.date.id.date
    }

    //фильтрация по событиями
    if (filter?.score?.id) {
        const tmp = filter.score.id;
        if (tmp?.date) {
            startCalc = tmp.date;
            finishCalc = tmp.date;
        }
        if (tmp?.mch)
            params += '&mch=' + tmp.mch;
        if (tmp?.station)
            params += '&station=' +tmp.station;
    }
 
    let url = sprintf(
        References.api.event_filtered,
        encodeURIComponent(startCalc),
        encodeURIComponent(finishCalc)
   )

   //доп фильтрация
    url += params;

    return AuthService.fetch(url)
        .then(res => res.json())
        .catch(() => console.log('event_filtered'));
}

export const loadEventIntegral = (date) => {
    const url = sprintf(
        References.api.event_integral,
        encodeURIComponent(dayjs(date, References.dateTimeFormat).format()),
    )
    return AuthService.fetch(url)
        .then(res => res.json())
        .catch(() => console.log('event_integral'));
}

export const showEventDate = (date) => {
    return dayjs(date).format('DD.MM');
}

export const showEventDateTime = (date) => {
    return dayjs(date).format('DD.MM HH:mm')
}

export const getLocaleDate = (delta = 0) => {
    return new Date(new Date().getTime() + delta).toLocaleString(References.locale)
}

export const showEventFilteredValue = (data) => {
    try {
        const mchInfo = References.mchs[data?.type];
        if (!mchInfo)
            throw new Error('no_mch');
        if (!data.value[mchInfo.field])
            return '---'            
        if (!data.value.hasOwnProperty(mchInfo.field))
            throw new Error('no_value');
        if (!data.value.hasOwnProperty(mchInfo.field))
            throw new Error('unknown');
        return `${round(data.value[mchInfo.field], mchInfo.precision)} ${mchInfo.unit}`;
    } catch (error) {
        return '---';         
    }
}

export const getWaterStateSVG = (state, type) => {
    const iconsIndex = References.event.icons_index.hasOwnProperty(type) ? References.event.icons_index[type] : 0;
    const svg = [{
        "state_-2": waterState_2,
        "state_0": waterState0,
        "state_10": waterState10,
        "state_20": waterState20,
        "state_30": waterState30,
        "state_40": waterState40       
    }, {
        "state_-2": rainState_2,
        "state_0": rainState_0,
        "state_10": rainState_10,
        "state_20": rainState_20,
        "state_30": rainState_30,
        "state_40": rainState_40
        
    }]

    return svg[iconsIndex][`state_${state}`];
}

export const isActiveFilterItem = (key, value, filter) => {
    if (!filter[key])
        return false;
    return (filter.hasOwnProperty(key) && JSON.stringify(filter[key].id) === JSON.stringify(value))
}

export const parseEventIntegral = ( events ) => {
    const firstEventData = Object.values(events || {})[0];
    return firstEventData?.mchs || {};
}

export const filterIntegralByHolders = ( holders, data ) => {    
    if (!holders || holders.length === 0)
        return data || {};

    if (!data || typeof data !== 'object')
        return {};

    const result = new Object();
    for (const[ date, mchs ] of Object.entries(data)) {
        Object.entries(mchs.mchs).forEach(([mch, stations]) => {
            Object.entries(stations.stations).forEach(([uuid, station]) => {

                //надо создать пустую структуру даже если нет постов 
                //при фильтрации по держателю
                result[date] ??= {}
                result[date].mchs ??= {}

                if (holders.indexOf(station?.holder_uuid) !== -1) {
                        result[date].mchs[mch] ??= {}
                        result[date].mchs[mch].stations ??= {}
                        result[date].mchs[mch].stations[uuid] = station;
                }
            })
        })
        break;
    }
    return result;
}

export const getEventIntegralTickState = (currentDate, event) => {

    dayjs.extend(isSameOrAfter);    
    dayjs.extend(isSameOrBefore);

    let className = '';
    event?.events.forEach((listEvents) => {
            const checkDate = dayjs(currentDate);
            if (
                checkDate.isSameOrAfter(listEvents.time_start, 'minute') && 
                checkDate.isSameOrBefore(listEvents.time_end, 'minute')
            ) {
                className = `state-background_${listEvents.danger_level_code}`
            }
    })

    return className.length > 0 ? className : null;
}


export const getEventIntegralTickValue = (currentDate, event, mch) => {

    dayjs.extend(isSameOrAfter);    
    dayjs.extend(isSameOrBefore);

    let value = null;
    event?.events.forEach((listEvents) => {
        const checkDate = dayjs(currentDate);
        if (
            checkDate.isSameOrAfter(listEvents.time_start, 'minute') && 
            checkDate.isSameOrBefore(listEvents.time_end, 'minute')  
        ) {
            const prec = References.mchs[mch].precision;
            const field = event?.criteria && References.event.criteria_field[event.criteria] ? References.event.criteria_field[event.criteria].field : References.mchs[mch].field;
            const unit = References.mchs[mch].unit;
            value = `${round(listEvents?.value[field], prec)} ${unit}`
        }
    })
    return value;
}

//
//    фильтрация по держателям
//    с пересчетом summary количества событий
//
export const filterByHolders = (holders, data) => {
    if (holders.length === 0)
        return data;

    const result = structuredClone(data);    
    Object.keys(result).forEach(date => {
        const stations = Object.keys(result[date]?.stations)
    
        //сбрасываем все summary
        Object.entries(result[date]?.summary?.mchs).forEach(([mch, score]) => {
            Object.entries(score.score).forEach(([state, _]) => {
                result[date].summary.mchs[mch].score[state] = 0
            })
        })

        stations.forEach(station => {
            const isHidden = holders.indexOf(result[date].stations[station]?.holder_uuid) === -1;            
            result[date].stations[station]['hidden'] = isHidden;

            //если пост показываем, то изменяем и summary для этого дня
            if (!isHidden) {
                Object.entries(result[date].stations[station].mchs).forEach(([mch, score]) => {
                    Object.entries(score.score).forEach(([state, _]) => {
                        result[date].summary.mchs[mch].score[state] += result[date].stations[station].mchs[mch].score[state] * 1
                    })
                })                
            }
        })
    })
    return result;
}

//
//  фильтрация раскрывающегося отфильтрованного списка событий
//
export const filterByHoldersFiltered = (holders, data) => {
    if (holders.length === 0 || data.length === 0)
        return data;

    const result = structuredClone(data);
    result.events.forEach((val, idx) => {
        result.events[idx]['hidden'] = holders.indexOf(val.station.holder_uuid) === -1
    });
    return result;
}

export const getEventFilterName = ( filter, key ) => {
    const keys = Object.keys(filter);
    if (keys.length === 0 || !filter[keys[0]].name.hasOwnProperty(key))
        return References.dictionary.all;

    return filter[keys[0]].name[key];
}

export const getEVentFilterDate = (filter) => {
    const keys = Object.keys(filter);
    if (keys.length > 0 && filter[keys[0]].id.hasOwnProperty('date'))
        return filter[keys[0]].id.date;

    return null;
}

export const isHasEvent = (score) => {
    if (!score)
        return false;
    const sum = Object.values(score).reduce((acc, value) => acc + value, 0);
    return sum > 0;
}